module.exports = __webpack_public_path__ + "img/bg-2.ae8ab797.jpg";